export const RATE_LIMIT_TOAST_ID = 'rate-limit-too-many-attempts';
export const RATE_LIMIT_TOAST_COOLDOWN_MS = 30 * 60 * 1000;
